import { NgModule } from "@angular/core";
import { CustomFieldsCoreModule } from "@webapp/custom-fields/custom-fields-core.module";
import { RolesCoreModule } from "@webapp/roles/roles-core.module";
import { TagsCoreModule } from "@webapp/tags/tags-core.module";

@NgModule({
  imports: [RolesCoreModule, CustomFieldsCoreModule, TagsCoreModule],
})
export class ConfigurationCoreModule {}
